import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=3fbb62f7&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports